import {connect, ConnectOptions, LocalTrack, Room} from 'twilio-video';
import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, ReplaySubject} from 'rxjs';
import {ApiService} from "./api.service";
import {VetineoApiResponse} from "../models/vetineo-api-response.model";
import {map} from "rxjs/operators";
import {CommonUtils} from "../utils/common";
import {SseService} from "./sse-service.service";
import {UserService} from "./user.service";
import {VetClinicService} from "./vet-clinic.service";

/**
 * NOT USED
 */
class AuthToken {
  accessToken: string;
}

/**
 * NOT USED
 */
export interface NamedRoom {
  id: string;
  name: string;
  maxParticipants?: number;
  participantCount: number;
}

export type Room = NamedRoom;

/**
 * NOT USED
 */
@Injectable({
  providedIn: 'root'
})
export class VideoChatService implements OnInit, OnDestroy{
  roomsUpdated: Observable<Room>;
  vetCode: number;

  private roomBroadcast = new ReplaySubject<boolean>();

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    public commonUtils : CommonUtils,
    private sseService: SseService,
    private userService: UserService,
    private vetClinicService: VetClinicService
  ) {
    this.roomsUpdated = this.roomBroadcast.asObservable();
  }

  private async getAuthToken(vetReservationUUID: string) {
    return this.apiService.get<VetineoApiResponse>(`/dashboard/twilio/get-access-token/${vetReservationUUID}`).pipe(map(vetineoApiResponse => {
      if (vetineoApiResponse.ok && vetineoApiResponse.response) {
        return this.commonUtils.bestTypedCopyEver<AuthToken>(new AuthToken(), vetineoApiResponse.response);
      }
    })).toPromise<AuthToken>();
  }

  private async updateTwilioRoomSIDs(vetReservationUUID: string, roomSID: string) {
    return this.apiService.post<VetineoApiResponse>(`/dashboard/twilio/update-room-sids`, { 'vetReservationUUID':vetReservationUUID, 'roomSID': roomSID }).pipe(map(vetineoApiResponse => {
      if (vetineoApiResponse.ok) {
        return true;
      } else {
        return false;
      }
    })).toPromise<boolean>();
  }

  async joinOrCreateRoom(vetReservationUUID: string, tracks: LocalTrack[]) {
    let room: Room = null;
    try {
      const token = await this.getAuthToken(vetReservationUUID);
      room =
        await connect(
          token.accessToken, {
            vetReservationUUID,
            tracks,
            dominantSpeaker: true
          } as ConnectOptions);
    } catch (error) {
      console.error(`Unable to connect to Room: ${error.message}`);
    } finally {
      if (room) {
        console.log('Connected to room: ', room.name)

        const roomSIDUpdate = await this.updateTwilioRoomSIDs(vetReservationUUID, room.sid);

        if (roomSIDUpdate) console.log('Room sids updated')

        this.roomBroadcast.next(true);
      }
    }

    return room;
  }

  nudge() {
    this.roomBroadcast.next(true);
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
  }
}
